// WebWorker.js

export default class WebWorker {
	constructor(workerName, workerModule, onSuccess, onError) {
		this.worker = null;
		this.workerName = workerName;
		this.workerModule = workerModule;
		this.onSuccess = onSuccess;
		this.onError = onError;

		this.messageDone = this.messageDone.bind(this);
		this.initWorker();
	}

	initWorker() {
		this.worker = this.createWorker(this.workerModule);
		this.worker.addEventListener("message", this.messageDone);
		this.worker.addEventListener(
			"error",
			this.onError ? this.onError : this.genericOnError
		);
	}

	messageDone = event => {
		setTimeout(() => {
			this.onSuccess(event.data);
		}, 0);
	};

	createWorker(workerModule) {
		const code = workerModule.toString();
		const blob = new Blob(["(" + code + ")()"]);
		return new Worker(URL.createObjectURL(blob));
	}

	execute(args) {
		if (this.worker == null) this.initWorker();
		setTimeout(() => {
			this.worker.postMessage(args);
		}, 0);
	}

	terminate() {
		this.worker.terminate();
		this.worker = null;
	}

	genericOnError = event => {
		console.error(event);
	};
}
